import { Box, Button, Stack, Typography } from "@mui/material";
import {
  DynamicUploadInput,
  StyledCheckboxInputs,
  StyledTextInput,
  StyledUploadInput,
} from "../../../../Reuse/FormInput";
import { useWatch } from "react-hook-form";
import { CheckValue } from "../../../../Service/service";

const imageAccept = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
};

const FirmwareFormComponent = (props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { value, errors, isSubmitting },
    onSubmit,
    onCancel,
  } = props;
  const build = useWatch({ control, name: `build` });
  return (
    <Box
      sx={{
        maxWidth: "90%",
        minWidth: "50%",
        mx: "auto",
        mt: 4,
        px: { xs: 2, sm: 3 },
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction={"column"} gap={3}>
          <DynamicUploadInput
            name="build"
            control={control}
            label="Firmware Build"
            helperText="Upload the build file for the firmware."
            uploadType="file"
            // accept={imageAccept}
            required="Build file is required"
          />
          {CheckValue(build) && (
            <Typography variant="h5" color="textSecondary">
              {build.name}
            </Typography>
          )}

          {/* Firmware Link */}
          {/* <StyledTextInput
            label="Firmware Link"
            name="link"
            control={control}
            showLabel={true}
            placeholder="Enter firmware link"
            rules={{ required: "Firmware link is required" }}
          /> */}
          {/* Firmware Version */}
          <StyledTextInput
            label="Firmware Version"
            name="version"
            control={control}
            showLabel={true}
            placeholder="Enter firmware version"
            rules={{ required: "Firmware version is required" }}
          />
          {/* Hash */}
          <StyledTextInput
            label="Hash"
            name="hash"
            control={control}
            showLabel={true}
            placeholder="Enter hash"
            rules={{ required: "Hash is required" }}
          />
          <StyledCheckboxInputs
            name="forceUpdate"
            control={control}
            label="Force Update"
          />

          <Stack direction="row" gap={2} justifyContent="flex-end" mt={4}>
            <Button variant="contained" type="submit" sx={{ height: 44 }}>
              Submit
            </Button>
            <Button variant="text" sx={{ height: 44 }} onClick={onCancel}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      </form>
    </Box>
  );
};

export default FirmwareFormComponent;
